var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('header-bar',{attrs:{"page-name":'live',"icon-color":'#7b7a7a',"facebookShareURL":"https://udn.com/newmedia/921/live/","lineShareURL":"https://udn.com/newmedia/921/live/"}}),_c('Covers'),_c('router-view')],1)}
var staticRenderFns = []

export { render, staticRenderFns }